import React from 'react'
import TrainerCard from './TrainerCard'
import NFt4 from "assets/img/nfts/Nft4.png";
function Trainers() {
  return (
    <>
    <div>
        <TrainerCard
        image={NFt4}
        />
        
    </div>
    </>
  )
}

export default Trainers